<template>
  <newsletter :data="newsletterData"/>
</template>
<script>
import Newsletter from "../Newsletter.vue";
import dynamicLocalization from "../../../mixins/dynamic-localization";
import newsletterData from './data.json';

export default {
  mixins: [dynamicLocalization],
  components: {
    Newsletter,
  },
  data() {
    return {
      newsletterData,
    };
  }
}
</script>
<i18n src="../i18n.json"/>
<i18n src="@/locales/global.json"/>
